var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintanance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3122 8.2579L18.8789 15.8246C19.2122 16.1579 19.2122 16.6829 18.8789 16.9996L16.9622 18.9162C16.6372 19.2412 16.1122 19.2412 15.7872 18.9162L8.19553 11.3246C6.2622 12.0496 4.00387 11.6412 2.45387 10.0912C0.537199 8.1829 0.362199 5.19124 1.9122 3.07457L5.10387 6.26624L6.2872 5.09124L3.0872 1.8829C5.2122 0.332902 8.19553 0.507902 10.1122 2.42457C11.6872 4.0079 12.0872 6.3079 11.3122 8.2579ZM8.49559 9.27458L16.3789 17.1579L17.1123 16.4162L9.23725 8.54125C9.62059 8.04958 9.87059 7.49958 9.97059 6.90791C10.1789 5.74958 9.83725 4.50791 8.93725 3.60791C8.14559 2.82458 7.10392 2.45791 6.07059 2.51625L8.64559 5.09125L5.11225 8.62458L2.53725 6.04958C2.47892 7.08291 2.84559 8.13291 3.63725 8.91625C4.50392 9.78291 5.69559 10.1246 6.82892 9.95791C7.42059 9.87458 7.98725 9.64958 8.49559 9.27458Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintanance);
export default __webpack_public_path__ + "static/media/maintanance.e4780769c950c08f5473418f5bc77978.svg";
export { ForwardRef as ReactComponent };